import ListPageWrapper from "../../ListPageWrapper";
import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {ContentParticipationValueObject} from "../../../data/value-object/content/ContentParticipationValueObject";
import {ContentParticipationSearchOption} from "../../../data/search-option/content/ContentParticipationSearchOption";
import {SearchIndex} from "../../../io/HttpClient";
import {SortOrder} from "ts-protocol-extension";
import {ContentParticipationIO} from "../../../io/ContentIO";
import {ContentParticipationDescription} from "../../../data/description/content/ContentParticipationDescription";
import {ContentParticipationDescriptor} from "../../../data/descriptor/content/ContentParticipationDescriptor";
import ListOption from "../../ListOption";
import {
    ContentParticipationSearchOptionDescription
} from "../../../data/description/content/ContentParticipationSearchOptionDescription";
import {
    applyContentParticipationSearchOption,
    ContentParticipationSearchOptionField
} from "../../search-option-field/content/ContentParticipationSearchOptionField";
import ListOrder from "../../ListOrder";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<ContentParticipationValueObject[]>([])
    const option = useStatePair<ContentParticipationSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={ContentParticipationIO}
                items={items}
                option={option.value}
                index={index}
                description={ContentParticipationDescription}
                descriptor={ContentParticipationDescriptor}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/contents/participations/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={ContentParticipationSearchOptionDescription}
                fields={ContentParticipationSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyContentParticipationSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={ContentParticipationDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}